<template>
  <div>
    <v-card-subtitle>
      <v-row>
        <v-col cols="12">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="addComponent()" small v-bind="attrs" v-on="on">
                <v-icon color="primary"> mdi-plus </v-icon>
              </v-btn>
            </template>
            <span>Inserisci Componente</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="saveDistinta()"
                small
                v-bind="attrs"
                v-on="on"
                class="ml-5"
              >
                <v-icon color="success"> mdi-floppy </v-icon>
              </v-btn>
            </template>
            <span>Salva Distinta Base</span>
          </v-tooltip>
        </v-col>
      </v-row>
    </v-card-subtitle>
    <v-card-text class="pt-5" style="max-height: 70vh; overflow-y: auto">
      <v-data-table
        :headers="headers"
        :items="
          CommessaData.commessa_distinta
            ? CommessaData.commessa_distinta.filter((e) => e.validita == 1)
            : []
        "
        :item-key="'index_id'"
        dense
      >
        <template v-slot:[`item.unita_misura`]="{ item }">
          {{
            item.unita_misura != null && item.unita_misura != ""
              ? item.unita_misura
              : "N/D"
          }}
        </template>
        <template v-slot:[`item.quantita`]="{ item }">
          <v-col cols="6">
            <v-text-field
              @change="item.modifica_produzione = 1"
              v-model.number="item.quantita"
              type="number"
              dense
            ></v-text-field>
          </v-col>
        </template>
        <template v-slot:[`item.edit`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="getAlt(item)" small v-bind="attrs" v-on="on">
                <v-icon color="primary"> mdi-pencil </v-icon>
              </v-btn>
            </template>
            <span>Modifica Componente</span>
          </v-tooltip>
        </template>
        <template v-slot:[`item.remove`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="clickRemove(item)" small v-bind="attrs" v-on="on">
                <v-icon color="error"> mdi-close </v-icon>
              </v-btn>
            </template>
            <span>Rimuovi Componente</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </v-card-text>
    <v-dialog
      content-class="hideoverflow"
      persistent
      hide-overlay
      v-model="articoloDialog"
      width="60vw"
    >
      <v-card>
        <v-toolbar dense class="headline indigo darken-1" primary-title>
          <v-toolbar-title class="white--text">
            {{ alternativeMode ? "Articoli Alternativi" : "Cerca Articolo" }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="
                  articoloDialog = false;
                  modalita_editing = '';
                "
                small
              >
                <v-icon class="" v-on="on" v-bind="attrs" color="error"
                  >mdi-close</v-icon
                >
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-subtitle>
          <v-form v-on:submit.prevent="searchArticoli" v-if="!alternativeMode">
            <v-container>
              <v-row>
                <v-col class="d-flex" cols="12" md="3">
                  <v-text-field
                    type="text"
                    v-model="cod_articolo"
                    class="shrink"
                    label="Ricerca Componente"
                    placeholder="Ricerca Componente"
                    required
                  ></v-text-field>
                </v-col>
                <v-col class md="1">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn class="mt-5" @click="searchArticoli" small>
                        <v-icon
                          v-on="on"
                          v-bind="attrs"
                          color="#1a80b6"
                          size="32"
                          >mdi-magnify</v-icon
                        >
                      </v-btn>
                    </template>
                    <span>Cerca </span>
                  </v-tooltip>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-subtitle>
        <v-container fluid style="max-height: 60vh; overflow-y: auto">
          <v-data-table :headers="articoli_headers" :items="articoli" dense>
            <template v-slot:[`item.pulsante`]="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    @click="selectArticolo(item)"
                    small
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon color="success"> mdi-check </v-icon>
                  </v-btn>
                </template>
                <span>Seleziona Componente</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </v-container>
        <v-card-actions>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <SnackbarQV ref="SnackbarQV" />

    <!-- Dialog di conferma eliminazione dei partner -->
    <v-dialog v-model="conferma_rimuovi" width="unset">
      <v-card style="max-width: 500px">
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text"> Eliminazione </v-toolbar-title>
        </v-toolbar>
        <v-card-text class="mt-5" style="overflow-y: auto">
          <span style="color: rgb(0, 0, 0); font-size: 18px">
            Confermi di voler eliminare il componente selezionato?
          </span>
          <v-divider class="my-5"></v-divider>
          <v-container>
            <v-row align="center" justify="center">
              <v-col class="my-0 py-0" justify="center" cols="12">
                <v-btn
                  class="mr-5"
                  @click="
                    conferma_rimuovi = false;
                    componente_sel = null;
                  "
                  small
                >
                  <v-icon color="error"> mdi-close </v-icon>
                </v-btn>

                <v-btn @click="remove(componente_sel)" small>
                  <v-icon color="success"> mdi-check </v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Overlay -->
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";
export default {
  name: "WODistintaBase",
  components: {
    SnackbarQV,
  },
  props: {
    idCommessa: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      // Variabili di supporto
      alternativeMode: false,
      articoli: [],
      cod_articolo: "",
      CommessaData: [],
      componente_sel: null,
      id_componente_sel: null,
      modalita_editing: "",
      modify: false,

      // Modal
      articoloDialog: false,
      conferma_rimuovi: false,
      overlay: false,

      // Array
      headers: [
        {
          text: "Modifica Distinta Base",
          value: "edit",
          sortable: false,
          width: "150px",
        },
        {
          text: "Articolo",
          value: "name",
        },
        {
          text: "Quantita",
          value: "quantita",
        },
        {
          text: "Unita di Misura",
          value: "unita_misura",
        },
        {
          text: "",
          value: "remove",
        },
      ],
      articoli_headers: [
        {
          text: "",
          value: "pulsante",
        },
        {
          text: "Codice Articolo",
          value: "cod_articolo",
        },
        {
          text: "Descrizione",
          value: "des_articolo",
        },
      ],
    };
  },
  methods: {
    clickRemove(arg) {
      this.componente_sel = arg;
      this.conferma_rimuovi = true;
    },
    saveDistinta() {
      let setcommessa = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "setcommessa",
          token: localStorage.getItem("user_token"),
          id_commessa: this.CommessaData.commessa.id_commessa,
          id_articolo: this.CommessaData.commessa.id_articolo,
          id_profilo: localStorage.id_profilo,
          tabella: [this.CommessaData],
        },
      };

      this.overlay = true;

      this.$store
        .dispatch("api", setcommessa)
        .then(async () => {
          this.overlay = false;
          this.$refs.SnackbarQV.print(
            "success",
            "Commessa Distinta Base Salvata"
          );
          this.modalita_editing = "";
        })
        .catch((e) => {
          this.overlay = false;
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, impossibile salvare i dati."
          );
        });
    },
    selectArticolo(item) {
      /* Se sto scegliendo un articolo in modalità edit vuol
       * dire che sto sostituendo un componente con un altro,
       * quindi cancello il componente vecchio e aggiungo
       * quello che ho scelto. */
      if (this.modalita_editing === "edit") {
        this.CommessaData.commessa_distinta.filter(
          (e) => e.id != this.id_componente_sel
        )[0].modifica_produzione = 1;

        const arr_tmp = Array.from(this.CommessaData.commessa_distinta).filter(
          (e) => e.id != this.id_componente_sel
        );

        this.CommessaData.commessa_distinta = JSON.parse(
          JSON.stringify(arr_tmp)
        );
        this.CommessaData.commessa_distinta.push({
          id: this.alternativeMode ? item.id_alternativo : item.id_articolo,
          id_articolo: this.CommessaData.commessa[0].id_articolo,
          id_commessa: this.CommessaData.commessa[0].id_commessa,
          id_commessa_distinta_base: -1,
          id_componente: this.alternativeMode
            ? item.id_alternativo
            : item.id_articolo,
          id_rif: 0,
          index_id: this.CommessaData.commessa_distinta.length,
          materiale_sotto_lotto: 0,
          modifica_produzione: 1,
          name: item.des_articolo,
          quantita: 1,
          validita: 1,
        });
        this.articoloDialog = false;
        this.modalita_editing = "";
      } else if (this.modalita_editing === "add") {
        this.CommessaData.commessa_distinta.push({
          id: this.alternativeMode ? item.id_alternativo : item.id_articolo,
          id_articolo: this.CommessaData.commessa[0].id_articolo,
          id_commessa: this.CommessaData.commessa[0].id_commessa,
          id_commessa_distinta_base: -1,
          id_componente: this.alternativeMode
            ? item.id_alternativo
            : item.id_articolo,
          id_rif: 0,
          index_id: this.CommessaData.commessa_distinta.length,
          materiale_sotto_lotto: 0,
          modifica_produzione: 1,
          name: item.des_articolo,
          quantita: 1,
          validita: 1,
        });
        this.articoloDialog = false;
        this.modalita_editing = "";
      }
    },
    remove(item) {
      /* Se l'oggetto eliminato è nuovo lo cancello e basta,
       * se invece l'oggetto era lì da prima gli segno che
       * il componente è stato modificato da avanzamento
       * produzione. */
      if (item.id_commessa_distinta_base == -1) {
        var index = 0;
        for (let i = 0; i < this.CommessaData.commessa_distinta.length; i++) {
          const e = this.CommessaData.commessa_distinta[i];
          if (e.id == item.id && e.quantita == item.quantita) {
            index = i;
            break;
          }
        }
        this.CommessaData.commessa_distinta.splice(index, 1);
      } else {
        item.modifica_produzione = 1;
        item.validita = 0;
      }

      this.conferma_rimuovi = false;
    },
    getAlt(item) {
      this.id_componente_sel = item.id;
      let getdistintabase = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getarticoloalternativo",
          token: localStorage.getItem("user_token"),
          filter: " AND articolo_residuo ISNULL OR articolo_residuo = 0 ",
          id_articolo: item.id,
        },
      };
      this.$store.dispatch("api", getdistintabase).then((res) => {
        this.articoli = res.data.result;
        this.alternativeMode = true;
        this.articoloDialog = true;
        this.modalita_editing = "edit";
      });
    },
    addComponent() {
      this.alternativeMode = false;
      this.articoloDialog = true;
      this.modalita_editing = "add";
    },
    searchArticoli(evt) {
      evt.preventDefault();
      let getdistintabase = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getarticoli",
          token: localStorage.getItem("user_token"),
          cod_articolo: this.cod_articolo,
        },
      };
      this.$store.dispatch("api", getdistintabase).then((res) => {
        this.articoli = res.data.lista;
        this.$forceUpdate();
      });
    },
    loadCommessa() {
      let getcommessa = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getcommessafull",
          token: localStorage.getItem("user_token"),
          id_commessa: this.idCommessa,
          id_profilo: localStorage.id_profilo,
        },
      };
      this.$store.dispatch("api", getcommessa).then((res) => {
        this.overlay = false;
        // Controllo che ci sia la distinta base, se c'è la registro.
        if (res.data.commessa_distinta) {
          /* Assegno un indice diverso a ogni componente della distinta base
           * per convenienza di v-data-table, altrimenti pesca come chiave di
           * riferimento il parametro id, che spesso è comune a più oggetti.*/
          for (let i = 0; i < res.data.commessa_distinta.length; i++) {
            res.data.commessa_distinta[i].index_id = i;

            // Per i componenti validi faccio in modo che la quantita sia un numero.
            if (res.data.commessa_distinta[i].validita == 1) {
              res.data.commessa_distinta[i].quantita = parseFloat(
                (res.data.commessa_distinta[i].quantita + "").replace(",", ".")
              );
            }
          }
          this.CommessaData = res.data;
        }
      });
    },
  },
  mounted() {
    this.loadCommessa();
  },
};
</script>